import {observer} from "mobx-react"
import {Linq, Page, Pager, ScrollTable} from "../../ui"
import {useNavigate} from "react-router"
import {cmsListStore} from "../../../store"

const CmsOverviewPage = observer(function CmsOverviewPage() {
    const navigate = useNavigate()
    return <Page
        breadcrumb={[
            {
                link: '/cms',
                label: `Kundenverwaltung`
            }
        ]}
        actions={[
            {
                label: 'Neuen Kunden anlegen',
                action: () => navigate('/cms/create'),
                icon: 'add'
            }
        ]}
    >
        <ScrollTable>
            <thead>
            <tr>
                <th>Name</th>
                <th>Anzeigename</th>
                <th>Kundennummer (SAP)</th>
                <th>Aktiv</th>
            </tr>
            </thead>
            <tbody>
            {cmsListStore.items.map((val, index) => {
                const link = `/cms/${val.id}`
                return <tr key={index} className={`link ${val.active ? '' : 'disabled'}`} onClick={() => {
                    navigate(link)
                }}>
                    <td><Linq to={`${link}`}>{val.name}</Linq></td>
                    <td><Linq to={`${link}`}>{val.displayName}</Linq></td>
                    <td><Linq to={`${link}`}>{val.customerNumber}</Linq></td>
                    <td><Linq to={`${link}`}>{val.active ?
                        <span
                            className="material-symbols-outlined"
                            style={{color: 'var(--core-success-color-bright)'}}
                        >toggle_on</span> : <span
                            className="material-symbols-outlined"
                            style={{color: 'var(--core-danger-color)'}}>toggle_off</span>}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={cmsListStore.pages}/>
    </Page>
})

export {
    CmsOverviewPage
}
